import { DateTime } from 'luxon';

export function createNewItemCode(table, idCategoria, dbRef) {
  const sql = `SELECT codigo FROM ${table} WHERE id_categoria = ? ORDER BY codigo DESC`;
  const selectStmt = dbRef.prepare(sql);
  const matches = selectStmt.all(idCategoria);
  if (matches.length > 0) {
    const lastInsertedCode = matches[0].codigo;
    return lastInsertedCode + 1;
  }
  return (idCategoria * 10000) + 1;
}

/**
 * Returns a string representation of a float
 */
export function formatDecimal(num) {
  // parseFloat(num).toFixed(1)
  const formatted = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 2, }).format(num);
  return formatted ? formatted : 0;
}

export function todayISODate() {
  const today = DateTime.local().toISODate();
  return today;
}

export function createNewDateString(date = new Date()) {
  const IsoDate = (date && typeof date == Date) ? date.toISOString() : new Date().toISOString();
  // const dateString = moment(IsoDate).format("YYYY-MM-DD HH:mm:ss");
  const dateString = DateTime.fromISO(IsoDate).toFormat('yyyy-LL-dd HH:mm:ss', { locale: "es" });
  return dateString;
}

export function compareAndSortDates(dates) {
  if (dates.length == 1) {
    return dates;
  }
  const dateStr1 = dates[0];
  const dateStr2 = dates[1];
  const date1 = DateTime.fromFormat(dateStr1, "yyyy-MM-dd");
  const date2 = DateTime.fromFormat(dateStr2, "yyyy-MM-dd");
  const isBackward = date1.startOf("day") >= date2.startOf("day");
  return isBackward ? [dateStr2, dateStr1] : dates;
}

export function createRangeDateArray(dates = [DateTime.local(), DateTime.local()]) {
  const startIsoDate = (dates && typeof dates[0] == Date) ?
    DateTime.fromJSDate(dates[0]).toISO() : dates[0].toISO();
  const endIsoDate = (dates && typeof dates[1] == Date) ?
    DateTime.fromJSDate(dates[1]).toISO() : dates[1].toISO();
  const startDateStr = `${startIsoDate.split('T')[0]} 00:00:00`;
  const endDateStr = `${endIsoDate.split('T')[0]} 23:59:59`;
  return [startDateStr, endDateStr];
}

export function formatDateForHumans(ISOdate) {
  return DateTime.fromISO(ISOdate).toFormat('cccc dd LLLL, yyyy ', { locale: "es" });
}

export function getCurrentTime() {
  return DateTime.local().toLocaleString({ hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
}

export function calcElapsedTime(startDateTimeStr) {
  const startDateTime = DateTime.fromSQL(startDateTimeStr);
  const elapsed = startDateTime.diffNow(['days', 'hours']);
  return elapsed;
}

export function getElapsedTime(startDateTimeStr) {
  const elapsed = calcElapsedTime(startDateTimeStr);
  return {
    elapsedTime: elapsed.values,
    elapsedTimeStr: elapsed.negate().toFormat("d 'días y' h 'horas'")
  };
}

export function getTimeLeft(endDateTimeStr) {
  const elapsed = calcElapsedTime(endDateTimeStr);
  return {
    timeLeft: elapsed.values,
    timeLeftStr: elapsed.toFormat("d 'días y' h 'horas'")
  };
}

export function formatDateForPicker(date) {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${month}/${day}/${year}`
}

export function parseDate(date) {
  if (!date) return null
  const [month, day, year] = date.split('/')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

export function getMinLaundryDuration(billItems) {
  console.log(billItems);
  //TODO:  decide the logic to get the min duration for the client
  //   bought services from the users db chosen values or
  //   based on a calculation on each of the chosen services
}

export function humanDateFormat(dateStr, locale) {
  let humanReadable = null;
  if (dateStr) {
    const ISODate = new Date(dateStr).toISOString();
    humanReadable = DateTime.fromISO(ISODate).toFormat('cccc d LLLL y, T', { locale: locale ? locale : "en" });
  }
  return humanReadable;
}

export function localizeSqliteDate(dateStr) {
  const date = new Date(`${dateStr} UTC`);
  const ISODateStr = date.toISOString();
  return DateTime.fromISO(ISODateStr).toFormat('yyyy-MM-dd HH:mm:ss', { locale: "es" });
}

export function localToSqliteGmtDate(gmtDate = new Date()) {
  const ISODateStr = gmtDate.toISOString();
  const formatedDate = DateTime.fromISO(ISODateStr).toFormat('yyyy-MM-dd HH:mm:ss', { locale: "es" });
  const dateStr = formatedDate.substring(0, 10);
  return dateStr;
}

export function removeSpecialChars(str) {
  return str
    // .replace(/[ÀÁÂÃÄÅ]/g,"A")
    // .replace(/[àáâãäå]/g,"a")
    // .replace(/[ÈÉÊË]/g,"E")
    .replace(/[Á]/g, "A")
    .replace(/[á]/g, "a")
    .replace(/[é]/g, "e")
    .replace(/[Í]/g, "I")
    .replace(/[í]/g, "i")
    .replace(/[Ó]/g, "O")
    .replace(/[ó]/g, "o")
    .replace(/[Ú]/g, "U")
    .replace(/[ú]/g, "u")
  //.... all the rest
  // .replace(/[^a-z0-9]/gi,''); // final clean up
}

export function capitalizeWord(str) {
  if (typeof str !== 'string') return ''
  return str.charAt(0).toUpperCase() + str.slice(1);
}